export const config = {
    ServerRest: 'https://ugs3experiment.bristar.studio',
    uuid: {
        UnischoolBristarUuid: 'c7fbc6450a3e463a8506b132edfffcbe',
        ServerMaintenenceScheduleUuid: '47103b5babcc4ed5b9c2b73bb704bd86',
        CurriculumDefaultUuid: 'bff352266f0f493981f7e4203190aeaa'
    }
}

export default config